<!--
 * @Author: mzw
 * @Date: 2021-09-26 10:45:17
 * @LastEditors: zhangyu
 * @LastEditTime: 2021-12-24 08:58:22
 * @Description: 进度条组件
-->
<template>
  <div :class="['progress-bar', `${themeColor}-bar`]">
    <span class="bar-title">{{ barTitle }}</span>
    <ul>
      <li v-for="(item, index) in progressList" :key="item.key">
        <div
          :class="[
            'bar-status ',
            item.status == 'unfinished' ? 'unfinished' : ''
          ]"
        >
          <span v-if="item.status == 'finished'"
            ><i class="el-icon-check"></i
          ></span>
          <span v-else-if="item.status=='current'"><i style="color: #fff;" class="el-icon-more"></i></span>
          <span v-else-if="item.status == 'unfinished'">{{ index + 1 }}</span>
        </div>
        <span>{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: {
    progressList: {
      type: Array,
      default: () => {
        return []
      }
    },
    themeColor: {
      type: String
    },
    barTitle: {
      type: String
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.progress-bar {
  display: flex;
  align-items: center;
  // 蓝色进度条
  &.blue-bar {
    margin-bottom: 22px;
    .bar-title {
      color: #3d88d4;
    }
    & > ul {
      li {
        .bar-status {
          &::before {
            background: #3d88d4;
          }
          & > span {
            border: 4px solid #85c2fa;
            background: #3d88d4;
          }
        }
      }
    }
  }
  // 橙色进度条
  &.orange-bar {
    .bar-title {
      color: #ec7604;
    }
    & > ul {
      li {
        .bar-status {
          &::before {
            background: #ec7604;
          }
          & > span {
            border: 4px solid #ffbe7f;
            background: #ec7604;
          }
        }
      }
    }
  }
  .bar-title {
    font-size: 16px;
    margin-right: 15px;
  }
  & > ul {
    display: flex;
    width: 100%;
    align-items: flex-start;
    li {
      // width: 129px;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      & > span {
        line-height: 30px;
      }
      & > span.time {
        font-size: 12px;
      }
      .bar-status {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        &::before {
          content: '';
          width: 100%;
          height: 2px;
          display: block;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        & > span {
          width: 28px;
          height: 28px;
          border-radius: 14px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1;
        }
        // 未进行样式
        &.unfinished {
          &::before {
            background: #dcdcdc;
          }
          & > span {
            border: 4px solid #dcdcdc;
            background: #d2d1d1;
          }
        }
      }
    }
  }
}
</style>
